import type {Template} from '@helpers/select-template';

import {chooseAndDownloadTemplate} from '@helpers/fetch';
import chalk from 'chalk';

import {
  BACKEND_SIMPLE_NEST_REPO,
  DEFAULT_BACKEND_SIMPLE_NEST_PROJECT_NAME
} from '../constants/templates';

export const initBackend = async (): Promise<void> => {
  const templates: Template[] = [
    {name: DEFAULT_BACKEND_SIMPLE_NEST_PROJECT_NAME, repo: BACKEND_SIMPLE_NEST_REPO}
  ];

  const folder = await chooseAndDownloadTemplate(templates);

  if (folder) {
    process.stdout.write(chalk.green(`Template successfully downloaded to: ${folder}\n`));
  }
};
